import {LOAD_OUTBOUNDDATA_ERROR, LOAD_OUTBOUNDDATA_LOADING, LOAD_OUTBOUNDDATA_SUCCESS} from "./actions";

const initialState = {
    data: [],
    loading: false,
    error: ''
};

export default function reduxSagaReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_OUTBOUNDDATA_LOADING: {
            return {
                ...state,
                loading: true,
                error:''
            };
        }
        case LOAD_OUTBOUNDDATA_SUCCESS: {
            return {
                ...state,
                data: action.data,
                loading: false
            }
        }
        case LOAD_OUTBOUNDDATA_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.error
            };
        }
        default: {
            return state;
        }
    }
}